export const CHANGE_PASSWORD_KEY = 'CHANGE_PASSWORD';
export const CHANGE_POSITION_KEY = 'CHANGE_POSITION';
export const BLOCK_KEY = 'BLOCK';
